import React from 'react'

import { SepaFormData } from '@lib/validators/sepa'
import { SEPAForm } from '@pages/Checkout/Payment/SEPAForm'

interface SubscriptionSEPAFormProps {
  data: SepaFormData
  onChange: (data: SepaFormData) => void
  errors?: Record<string, string>
  disabled?: boolean
}

export const SubscriptionSEPAForm: React.FC<SubscriptionSEPAFormProps> = props => {
  return <SEPAForm {...props} />
}
